<template>
    <div>
        <b-container>
            <b-row><b-col>
                <h4>{{ $t('traffic_deviations.canceled_departures.course') }}</h4>
            </b-col><b-col>
                <SelectList 
                :placeholder="datePlaceholder"
                :options="dateOptions"  
                @select="onSelectDate" 
                :searchable="false" 
                :clearable="false" 
                :disabled="loading"
                :value="selectedDate" />
            </b-col></b-row>
            <b-row><b-col>
                <b-form-input type="search" class="string-filter" v-model="courseFilter" :placeholder="$t('traffic_deviations.canceled_departures.search_by_course')" debounce="300" ></b-form-input>
            </b-col></b-row>
            <b-row><b-col>
                <b-form-input type="search" class="string-filter" v-model="vehicleFilter" :placeholder="$t('traffic_deviations.canceled_departures.search_by_vehicle')" debounce="300" ></b-form-input>
            </b-col></b-row>
            <b-row><b-col>
                <input type="checkbox" id="cb-canceled-courses-only" v-model="canceledCoursesOnly" />
                <label :for="'cb-canceled-courses-only'">{{ $t('traffic_deviations.canceled_departures.show_canceled_only') }}</label>
            </b-col></b-row>
            <b-row><b-col>
                <b-form-checkbox-group
                id="cb-course-canceled"
                name="cb-course-canceled"
                v-model="coursesWithCancellations">
                <b-table
                    :fields="courseListFields"
                    :items="courseListItems"
                    selectable
                    select-mode="single"
                    @row-selected="onSelectCourse"
                    :per-page="perPage"
                    :current-page="currentPage">
                    <template v-slot:cell(tripsCanceled)="data">
                        <b-form-checkbox :value="data.item.courseNumber" :disabled="true"></b-form-checkbox>
                    </template>
                </b-table>
                </b-form-checkbox-group>
                <TablePagination
                :total-rows="totalRows"
                :per-page="perPage"
                @pageChange="onPageChange"
                ></TablePagination>
            </b-col></b-row>
        </b-container>
        <CanceledDeparturesConfirm
			modalid="confirmDateModal"
            :message="$t('traffic_deviations.canceled_departures.confirm_reset')"
            :value="dateValue"
			id="confirmDateModal"
            ref="confirmDateModal"
			@ok="onDateConfirmed"
		></CanceledDeparturesConfirm>
    </div>
</template>

<script>
import CanceledDeparturesConfirm from '@/components/Dispatching/TrafficDeviations/CanceledDeparturesConfirm.vue';
import { haveCancellationsBeenModified } from '@/store/dispatching/trafficDeviations.js';

export default {
    name: 'CourseTable',
    components: { CanceledDeparturesConfirm },
    data() {
        return {
            loading: true,
            perPage: 15,
            currentPage: 1,
            coursesWithCancellations: [],
            dateToSelect: '',
            courseFilter: '',
            vehicleFilter: '',
            canceledCoursesOnly: false
        };
    },
    computed: {
        datePlaceholder() {
            return this.$t('traffic_deviations.canceled_departures.date_placeholder');
        },
        dateOptions() {
            let options = [];
            for (const date of this.$store.state.trafficDeviations.dateList) {
               options.push({ id: date, label: date, icon: "calendar2-date" });                
            }
            return options;
        },
        selectedDate() {
            return this.$store.state.trafficDeviations.selectedDate;
        },
        dateValue() {
            return this.dateToSelect;
        },
        courseListFields() {
            return [
                { key: 'tripsCanceled', label: this.$t('traffic_deviations.canceled_departures.cancellations'), sortable: false },
                { key: 'courseNumber', label: this.$t('traffic_deviations.canceled_departures.course_number'), sortable: false },
                { key: 'vehicleLabels', label: this.$t('traffic_deviations.canceled_departures.vehicle_number'), sortable: false, formatter: (value) => {
                    if (Array.isArray(value)) {
                        return value.join(', ');
                    }
                    return '';
                }}
            ];
        },
        courseListItems() {
            let resultList = this.$store.state.trafficDeviations.courseAndVehicleList;
            if (this.courseFilter && this.courseFilter.length > 0) {
                resultList = resultList.filter(course => course.courseNumber.indexOf(this.courseFilter) > -1);
            }
            if (this.vehicleFilter && this.vehicleFilter.length > 0) {
                resultList = resultList.filter(course => {
                    if (!Array.isArray(course.vehicleLabels)) {
                        return false;
                    }
                    for (const label of course.vehicleLabels) {
                        if (label && label.indexOf(this.vehicleFilter) > -1)
                            return true;
                    }
                    return false;
                });
            }
            if (this.canceledCoursesOnly) {
                resultList = resultList.filter(course => course.tripsCanceled == 'true');
            }
            return resultList;
        },
        totalRows() {
            return this.courseListItems ? this.courseListItems.length : 0;
        }
    },
    beforeCreate() {
        this.$store.dispatch('trafficDeviations/getDateList').finally(() => {
            this.loading = false;
        });
    },
    methods: {
        onSelectDate(value) {
            if (!this.$UIPrivilege('dispatching/canceleddepartures', 'update')) {
                this.onDateConfirmed(value);
                return;
            }
            if (haveCancellationsBeenModified()) {
                this.dateToSelect = value;
                this.$refs.confirmDateModal.show();
            }
            else {
                this.onDateConfirmed(value);
            }
        },
        onDateConfirmed(value) {
            this.$store.commit('trafficDeviations/updateSelectedDate', value);
            this.loading = true;
            this.$store.dispatch('trafficDeviations/getCourseAndVehicleList', value).finally(() => {
                this.loading = false;
            });
        },
        onSelectCourse(value) {
            if (value[0]) {
                this.$store.commit('trafficDeviations/updateSelectedCourseNumber', value[0].courseNumber);
                this.$store.commit('trafficDeviations/updateSelectedCourseWithVehicles', value[0]);
            }
        },
        onPageChange(page) {
            this.currentPage = page
        },
        onFiltered() {
            this.currentPage = 1;
        }
    },
    watch: {
        courseListItems(courseAndVehicleList) {
            let canceled = [];
            if (Array.isArray(courseAndVehicleList)) {
                for (const cnv of courseAndVehicleList) {
                    if (cnv.tripsCanceled == 'true')
                        canceled.push(cnv.courseNumber);
                }
            }
            this.coursesWithCancellations = canceled;
        },
        courseFilter() {
            this.onFiltered();
        },
        vehicleFilter() {
            this.onFiltered();
        },
        canceledCoursesOnly() {
            this.onFiltered();
        }
    }
}
</script>

<style scoped lang="scss">

.string-filter {
    margin-bottom: 5px;
}

#cb-canceled-courses-only {
    margin-right: 5px;
}

</style>